import React, { useState } from "react";
import { Form, Input, Button, Typography, Spin, message } from "antd";
import LeftLayout from "../../pageHeader/LeftLayout";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import { RightOutlined } from '@ant-design/icons';
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import _consumerService from "../../../modules/consumerService";


import HeaderComponentWithTitleAndLogo from "../../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../../components/MainLayout/MainLayout";
import SendOTP from "../../../components/SendOTP/SendOTP";

const { Title, Text, Link } = Typography;

const CreateConsumerAccount = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const onFinish = async (values) => {
        console.log(values)
        let reqObj = {
            Email: values.email
        }
        setLoading(true);
        try {
            const res = await _consumerService.sendVerifyConsumerEmailOTP(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                history.push({
                    pathname: routes.consumerVerifyotp.path,
                    state: { "email": values.email }
                });
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    return (
        <Spin spinning={loading}>
             <MainLayout>
                <HeaderComponentWithTitleAndLogo
                    logoSrc="/websiteLogo.png"
                    logoAlt="Leveridge Logo"
                    title="Create Account"
                    subtitle="Enter your email address to begin the registration process"
                />
                <SendOTP
                    onFinish={onFinish}
                    loading={loading}
                    infoText="Already have an account? "
                    goBackLinkLable="Login"
                    goBackLinkPath={() => history.push(routes.registeredEmail.path)}
                />
            </MainLayout>
            {/* <LeftLayout>
                <div className="w450">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Investor Portal
                    </Title>

                    <Form
                        name="verify-email"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Email address is required" },
                                {
                                    type: "email",
                                    message: "Please enter a valid email address",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Your Email" maxLength={50} />
                        </Form.Item>

                        <Text type="secondary" style={{ fontSize: 14 }}>
                            We will send an OTP to your email address for validation
                        </Text>

                        <Form.Item style={{ marginTop: 24 }}>
                            <Button
                                htmlType="submit"
                                size="large"
                                loading={loading}
                            >
                                Send OTP <RightOutlined />
                            </Button>
                        </Form.Item>
                    </Form>

                    <div style={{ marginTop: 40 }}>
                        <Link
                            onClick={() => history.push(routes.registeredEmail.path)}
                            style={{ fontWeight: "bold", fontSize: 14 }}
                        >
                            Already Have An Account?  <RightOutlined />
                        </Link>
                    </div>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default CreateConsumerAccount;
